import { registerEnum } from 'decapi'

export enum UserGroupRoleEnum {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

registerEnum(UserGroupRoleEnum, { name: 'UserGroupRoleEnum' })

export interface IUserGroup {
  user_id: number
  group_id: number
  role: UserGroupRoleEnum
}
